import { createSelector } from 'reselect';

const selectphases = (state: any) => state.phases;


export const selectphasesCurrentItem = createSelector([selectphases], (phases) => phases.current);

export const selectphasesListItems = createSelector([selectphases], (phases) => phases.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectphasesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectphasesQueryItems = createSelector([selectphases], (phases) => phases.query);

export const selectphasesCreatedItem = createSelector([selectphases], (phases) => phases.create);

export const selectphasesUpdatedItem = createSelector([selectphases], (phases) => phases.update);

export const selectphasesReadItem = createSelector([selectphases], (phases) => phases.read);

export const selectphasesDeletedItem = createSelector([selectphases], (phases) => phases.delete);

export const selectphasesSearchedItems = createSelector([selectphases], (phases) => phases.search);

export const selectphasesItemsCount = createSelector([selectphases], (phases) => phases.count);

export const selectphasesItemsFilter = createSelector([selectphases], (phases) => phases.filter);